import { EXPORT_STATS, GET_BOXSCORE } from "./constants";

const initialState = {
	jsonStats: {},
	boxScore: {}
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case GET_BOXSCORE:
		case EXPORT_STATS: {
			return {
				...state,
				...payload,
				isLoading: false
			};
		}
		default:
			return state;
	}
};

export default reducer;
